import Vue from "vue"
Vue.mixin({
	data() {
		return {

		}
	},
	methods: {
		$downloadFile(fid, sortType) {
			let url = this.domainName + '/download/file?fid=' + fid + '&sortType=' + sortType
			window.open(url, '_blank')
		},

		/**
		 * 通用文件预览
		 */
		$preview(fid, sortType) {
			let url = this.domainName + '/preview/file?fid=' + fid + '&sortType=' + sortType
			window.open(url, '_blank')
		},

		$previewFile(fileUrl) {
			if (!fileUrl) {
				return ''
			}
			if (fileUrl.indexOf('/') != 0) {
				fileUrl = '/' + fileUrl
			}
			return this.domainName + '/preview' + fileUrl
		},
		
	}

})



// WEBPACK FOOTER //
// ./src/mixin/download.js